import { all, put, takeLatest } from 'redux-saga/effects';

import { types as savedMegaQueryTypes } from '../ducks/savedMegaQuery';

export function * watchSavedMegaQuery() {
    yield takeLatest(savedMegaQueryTypes.SAVEDMEGAQUERY_GET, onSavedMegaQueryGet);
    yield takeLatest(savedMegaQueryTypes.SAVEDMEGAQUERY_SUCCESS, onSavedMegaQueryGetResponse);
}

export function * onSavedMegaQueryGet({ payload }) {
    payload.method = 'get';
    return yield payload;
}

export function * onSavedMegaQueryGetResponse({ response, payload }) {
    if (payload.action === 'get' && response && payload.dataset === 'savedMegaQuery') {
        return yield all([
            put({
                type: savedMegaQueryTypes.SAVEDMEGAQUERY_SET,
                payload: response,
            }),
        ]);
    }
}
